import PropTypes from 'prop-types';
import React from 'react';
import { Select } from '@opendate-app/setlist';

const SeatInventoryControls = ({ qty, maxQty, onQtyChange }) => (
  <div className="seat-card-qty">
    <div className="seat-card-qty-label">How many tickets do you need?</div>
    <Select
      aria-label="Number of tickets"
      value={qty}
      onChange={(value) => onQtyChange(parseInt(value, 10))}
      options={Array.from({ length: maxQty }, (_, i) => ({
        value: i + 1,
        label: `${i + 1} ${i === 0 ? 'ticket' : 'tickets'}`
      }))}
    />
  </div>
);

SeatInventoryControls.propTypes = {
  qty: PropTypes.number.isRequired,
  maxQty: PropTypes.number,
  onQtyChange: PropTypes.func.isRequired
};

SeatInventoryControls.defaultProps = {
  maxQty: 8
};

export default SeatInventoryControls;
